export default "__VITE_ASSET__289204e9__"